/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_LanguageInputs */

const en_select_language = /** @type {(inputs: Select_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select language`)
};

const th_select_language = /** @type {(inputs: Select_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกภาษา`)
};

const ja_select_language = /** @type {(inputs: Select_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語を選択`)
};

const fr_select_language = /** @type {(inputs: Select_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir la langue`)
};

const es_select_language = /** @type {(inputs: Select_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar idioma`)
};

const ru_select_language = /** @type {(inputs: Select_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите язык`)
};

const zh_select_language = /** @type {(inputs: Select_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择语言`)
};

const vi_select_language = /** @type {(inputs: Select_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ngôn ngữ`)
};

/**
* | output |
* | --- |
* | "Select language" |
*
* @param {Select_LanguageInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const select_language = /** @type {((inputs?: Select_LanguageInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_LanguageInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_select_language(inputs)
	if (locale === "ja") return ja_select_language(inputs)
	if (locale === "fr") return fr_select_language(inputs)
	if (locale === "es") return es_select_language(inputs)
	if (locale === "ru") return ru_select_language(inputs)
	if (locale === "zh") return zh_select_language(inputs)
	if (locale === "vi") return vi_select_language(inputs)
	return en_select_language(inputs)
});